import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BizCard from '../../components/UI/BizCard';
import { amountUnitDetails, currencyFormat, textareaToHtml } from '../../utils/globals';

const immovableRow = (entry) => (
  <tr key={entry.id}>
    <td>
      Mortgage of <strong>{entry.propertyType}</strong> situated at <strong>{entry.address}, {entry.city}, {entry.state} - {entry.pincode}</strong>,
      Measuring land area of <strong>{entry.plotArea}</strong> and construction of <strong>{entry.constructionArea}</strong> sq. ft.
      owned by <strong>{entry.ownedBy}</strong>
    </td>
    <td>{entry.product}</td>
    <td>{currencyFormat(entry.marketValue)}</td>
    <td>{entry.chargeNature}</td>
  </tr>
);

const movableRow = (entry) => (
  <tr key={entry.id}>
    <td>{entry.details}</td>
    <td>{entry.product}</td>
    <td>{currencyFormat(entry.marketValue)}</td>
    <td>{entry.chargeNature}</td>
  </tr>
);

class LeadApprovalSheet extends Component {
  render() {
    console.log(this.props);
    const { amountUnit } = this.props;
    const {
      companyName,
      currentProposal,
      movableSecurities,
      immovableSecurities,
      approvalAmount,
      termsOffered,
      otherCovenants,
      proposedFees,
    } = this.props.las;
    return (
      <BizCard title="Lead Approval Sheet">
        <table className="biz-form-table">
          <tbody>
            {/* Company Name */}
            <tr>
              <td className="biz-form-table-label">Company Name</td>
              <td className="biz-form-table-input">{companyName}</td>
            </tr>

            {/* Current Proposal */}
            <tr>
              <td className="biz-form-table-label">Current Proposal</td>
              <td className="biz-form-table-input">
                {
                  currentProposal.length > 0 ?
                    <table className="biz-data-table biz-bordered">
                      <thead>
                        <tr>
                          <th>Remark</th>
                          <th>CC</th>
                          <th>TL</th>
                          <th>LC</th>
                          <th>BG</th>
                          <th>Other</th>
                          <th>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          currentProposal.map((cp) => (
                            <tr key={cp.id}>
                              <td>{currencyFormat(cp.remark)}</td>
                              <td>{currencyFormat(cp.cc)} {amountUnitDetails[amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.tl)} {amountUnitDetails[amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.lc)} {amountUnitDetails[amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.bg)} {amountUnitDetails[amountUnit].symbol}</td>
                              <td>{currencyFormat(cp.other)} {amountUnitDetails[amountUnit].symbol}</td>
                              <td>
                                {currencyFormat(cp.tl + cp.cc + cp.bg + cp.lc + cp.other)} {amountUnitDetails[amountUnit].symbol}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    :
                    null
                }
              </td>
            </tr>

            <tr>
              <td className="biz-form-table-label">Primary Immovable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Product</th>
                      <th>Market Value</th>
                      <th>Nature of charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      immovableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                        immovableRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td className="biz-form-table-label">Collateral Immovable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Product</th>
                      <th>Market Value</th>
                      <th>Nature of charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      immovableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                        immovableRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td className="biz-form-table-label">Primary Movable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Product</th>
                      <th>Market Value</th>
                      <th>Nature of charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      movableSecurities.filter((element) => (element.type === 'primary')).map((entry) => (
                        movableRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
            </tr>

            <tr>
              <td className="biz-form-table-label">Collateral Immovable Security</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table biz-bordered">
                  <thead>
                    <tr>
                      <th>Particulars</th>
                      <th>Product</th>
                      <th>Market Value</th>
                      <th>Nature of charge</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      movableSecurities.filter((element) => (element.type === 'collateral')).map((entry) => (
                        movableRow(entry)
                      ))
                    }
                  </tbody>
                </table>
              </td>
            </tr>

            {/* Approval Amount */}
            <tr>
              <td className="biz-form-table-label">Approval Amount</td>
              <td className="biz-form-table-input">{currencyFormat(approvalAmount)}</td>
            </tr>

            {/* Terms Offered by Bizminder */}
            <tr>
              <td className="biz-form-table-label">Terms Offered by Bizminder</td>
              <td className="biz-form-table-input">{textareaToHtml(termsOffered)}</td>
            </tr>

            {/* Other Covenants */}
            <tr>
              <td className="biz-form-table-label">Other Covenants</td>
              <td className="biz-form-table-input">{textareaToHtml(otherCovenants)}</td>
            </tr>

            {/* Proposed Fees */}
            <tr>
              <td className="biz-form-table-label">Proposed Fees</td>
              <td className="biz-form-table-input">{proposedFees}</td>
            </tr>
          </tbody>
        </table>
      </BizCard>
    );
  }
}

LeadApprovalSheet.propTypes = {
  las: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  amountUnit: PropTypes.string.isRequired,
};

export default LeadApprovalSheet;



// WEBPACK FOOTER //
// ./src/pages/leads/LeadApprovalSheet.jsx